import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: 'General Inquiry', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className="contact-page page-wrapper">
      <div className="contact-hero">
        <p className="section-label">Get in Touch</p>
        <h1>Contact Us</h1>
        <p>We'd love to hear from you — for inquiries, appointments, or bridal consultations</p>
      </div>

      <div className="contact-body">
        {/* Info Cards */}
        <div className="contact-info">
          {[
            { icon: "📍", title: "Visit Us", lines: ["Dhadee Boutique, Main Bazaar Road", "Nagercoil, Tamil Nadu 629 001"] },
            { icon: "📞", title: "Call Us", lines: ["+91 98765 43210", "+91 99876 54321"] },
            { icon: "✉️", title: "Email Us", lines: ["dhadee@boutique.com", "bridal@dhadeeboutique.com"] },
            { icon: "🕐", title: "Hours", lines: ["Mon–Sat: 10am – 8pm", "Sunday: 11am – 6pm"] },
          ].map((c, i) => (
            <div key={i} className="info-card">
              <span className="info-icon">{c.icon}</span>
              <h4>{c.title}</h4>
              {c.lines.map((l, j) => <p key={j}>{l}</p>)}
            </div>
          ))}
        </div>

        {/* Form */}
        <div className="contact-form-wrap">
          {sent ? (
            <div className="success-msg">
              <span>✓</span>
              <h3>Thank You!</h3>
              <p>We've received your message and will get back to you within 24 hours.</p>
              <button className="btn-gold" onClick={() => setSent(false)}>Send Another</button>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2>Send a Message</h2>

              <div className="form-row">
                <div className="form-group">
                  <label>Your Name *</label>
                  <input name="name" value={form.name} onChange={handleChange} required placeholder="Priya Anand" />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="priya@email.com" />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone</label>
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="+91 98765 00000" />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <select name="subject" value={form.subject} onChange={handleChange}>
                    <option>General Inquiry</option>
                    <option>Bridal Consultation</option>
                    <option>Custom Stitching</option>
                    <option>Order Support</option>
                    <option>Wholesale</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  placeholder="Tell us about your requirements..."
                />
              </div>

              <button type="submit" className="btn-gold">Send Message →</button>
            </form>
          )}
        </div>
      </div>

      {/* Map */}
      <div className="map-section">
        <iframe
          title="Dhadee Boutique Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15773.247!2d77.4118!3d8.1794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b04f1a0c2f2f2f2%3A0x0!2sNagercoil%2C+Tamil+Nadu!5e0!3m2!1sen!2sin!4v1"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        />
      </div>
    </div>
  );
}
